export const poolId = 'eu-west-1_oFwmKfSww';
export const poolClientId = '3b4eu0n53iam2oue3lhnh18erc';
